export enum MaterialColor {
  ACCENT = 'accent',
  PRIMARY = 'primary'
}
